import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { UserOrg } from '../models/userOrg';

export const getUserOrgs: (excludeRestricted?: boolean) => Promise<UserOrg[]> = (excludeRestricted = false) => {
  return cacheableRequest(`/v2/user/organizations${excludeRestricted ? `?excludeRestricted=true` : ''}`).then(
    ({ data }: AxiosResponse<UserOrg[]>) => data
  );
};
